import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosEmpleadosRetiradosMixin = {
  computed: {
    permisosEmpleadosRetirados() {
      return {
        accesoModulo: tienePermiso('submoduloEmpleadosRetirados'),
      };
    },
  },
};
